module.exports = __webpack_public_path__ + "static/media/close.2bdd4758.png";